import { handleApi } from "common/utils/handleApi";
import { MODULES } from "shared/config";
import api, { baseApiService } from "shared/api";

// TODO Getting rid of code duplication
// ! handleApi deprecated

export const getCorporateCardRequests = async (userRole) => {
  return await handleApi(() =>
    api.post(baseApiService.ENDPOINTS.request.card.queue, {
      user_role: userRole,
      type: MODULES.CORPORATE_CARDS,
    })
  );
};
